/**
 * GET /api/v1/print-options.
 *
 * Both are read-only catalogue lookups, both are safe to cache, and neither
 * needs a session — the options screen has to work before the customer signs in.
 */
import { api } from './client';
import { queryKeys, useApiQuery } from './queryClient';
import type { PrintOptionOut } from './types';

export const PRINT_OPTIONS_PATH = '/api/v1/print-options';

export function fetchPrintOptions(signal?: AbortSignal): Promise<PrintOptionOut[]> {
  return api.get<PrintOptionOut[]>(PRINT_OPTIONS_PATH, signal ? { signal } : undefined);
}

/**
 * The preset catalogue. Cached for five minutes: an operator changing a price
 * mid-session must reach a long-lived tab eventually, but re-fetching the same
 * four rows on every step change is pure waste on a metered connection.
 */
export function usePrintOptions() {
  return useApiQuery<PrintOptionOut[], typeof queryKeys.printOptions>({
    queryKey: queryKeys.printOptions,
    queryFn: ({ signal }) => fetchPrintOptions(signal),
    staleTime: 5 * 60_000,
  });
}
